module.exports = __webpack_public_path__ + "assets/splunk_login_logo.svg";